//# sourceMappingURL=tab_bar.mjs.map
/// <reference types="./tab_bar.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $attribute from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList } from "../../gleam.mjs";

export function tab_bar(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius(px(8)),
      $css.overflow("hidden"),
    ]),
  );
  return $h.nav(_pipe, attrs, children);
}

export function tab(active, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.padding_("8px 20px"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.text_decoration("none"),
      $css.transition("color .3s, background .3s"),
      $css.cursor("pointer"),
      $css.text_align("center"),
      $css.gap(px(8)),
      $css.position("relative"),
      $css.background(
        (() => {
          if (active) {
            return $colors.light.blue_50;
          } else {
            return $colors.light.transparent;
          }
        })(),
      ),
      $css.color(
        (() => {
          if (active) {
            return $colors.light.blue_800;
          } else {
            return $colors.light.grey_800;
          }
        })(),
      ),
      $css.selector(":not(:first-child)", toList([$css.margin_left(px(1))])),
      $css.selector(
        ":not(:last-child)::after",
        toList([
          $css.content("\"\""),
          $css.background($colors.light.grey_200),
          $css.position("absolute"),
          $css.right(px(-1)),
          $css.width(px(1)),
          $css.height_("calc(100% - 10px)"),
          $css.position("absolute"),
        ]),
      ),
      $css.selector(
        "[disabled='True']",
        toList([
          $css.color($colors.light.grey_600),
          $css.border_bottom("none"),
          $css.pointer_events("none"),
        ]),
      ),
    ]),
  );
  return $h.a(_pipe, attrs, children);
}
